import React, { useMemo } from 'react'
import Image from 'next/image'
import styles from './styles.module.scss'
import { ListTags } from 'src/pages/List/components/ListTags'
import { StarContainer } from '../StarContainer'
import { useAppIntl } from 'src/i18n'

const TopList = ({ detailedReviewItems, getGeneralRatingScore }) => {
  const intl = useAppIntl()

  // Memoize the JSX for individual review items to avoid unnecessary re-renders
  const reviewItems = useMemo(() => {
    return detailedReviewItems.map((item, index) => (
      <div
        key={item.slug}
        className={`${styles.toplistItem} ${
          index === 0 ? styles.firstItem : styles.otherItem
        }`}
      >
        <div className={styles.toplistSection}>
          <div className={styles.toplistItemNumber}>{index + 1}</div>
          <div className={styles.toplistArticle}>
            <div className={styles.toplistArticleUpper}>
              <div className={styles.tabletLogo}>
                <div className={styles.tabletContainer}>
                  <a
                    href={item?.link}
                    target='_blank'
                    rel='noopener noreferrer nofollow'
                  >
                    <Image
                      src={item.thumbnail?.data?.attributes?.url}
                      alt='Logo'
                      width={100}
                      height={100}
                      loading='lazy'
                    />
                  </a>
                </div>
                <div className={styles.mobileTitle}>
                  <h2>
                    <a
                      className={styles.toplistItemTitleMobile}
                      href={item?.link}
                      target='_blank'
                      rel='noopener noreferrer nofollow'
                    >
                      {item.title}
                    </a>
                  </h2>
                  <p className={styles.overFlow}>{item?.shortPreview}</p>
                </div>
              </div>
              <div className={styles.overFlowMobile}>
                <p>{item?.shortPreview}</p>
              </div>
              <div className={styles.tabletTags}>
                {item.tags?.data?.map((tag, tagIndex) => (
                  <ListTags
                    key={tagIndex}
                    tags={tag}
                    backgroundColor='#1D1D1D'
                  />
                ))}
              </div>
              <div className={styles.prosMobile}>
                <div className={styles.readFullReviewMobile}>
                  <a href={`/review/${item.slug}`}>
                    <p>{intl.t('review.buttons.read')}</p>
                  </a>
                </div>
                <a
                  className={styles.startTrading}
                  href={item.affiliateLink}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <p>
                    {intl.t('review.buttons.visit')} {item.title}
                  </p>
                </a>
              </div>
              <div className={styles.toplistItemlogo}>
                <a
                  href={item?.affiliateLinkink}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                  style={{ width: '100%', height: '100%' }}
                >
                  <Image
                    src={item.thumbnail?.data?.attributes?.url}
                    alt='Logo'
                    layout='fill'
                    objectFit='cover'
                    loading='lazy'
                  />
                </a>
              </div>
              <div className={styles.toplistItemDescription}>
                <div className={styles.heading}>
                  <h2>
                    <a
                      className={styles.toplistItemTitle}
                      href={item?.affiliateLink}
                      target='_blank'
                      rel='noopener noreferrer nofollow'
                    >
                      {item.title}
                    </a>
                  </h2>
                </div>
                <div className={styles.previewWrapper}>
                  <p className={styles.overFlow}>{item?.shortPreview}</p>
                </div>
                <div className={styles.tags}>
                  {item.tags?.data?.map((tag, tagIndex) => (
                    <ListTags
                      key={tagIndex}
                      tags={tag}
                      backgroundColor='#1D1D1D'
                    />
                  ))}
                </div>
              </div>
              <div className={styles.toplistPros}>
                <div className={styles.toplistProsLeft}>
                  <ul>
                    {item.pros?.data?.slice(0, 3).map((pro, proIndex) => (
                      <div className={styles.icons} key={proIndex}>
                        <div className={styles.icons}>
                          <Image
                            src='/assets/icons/icon-check-circle.svg'
                            className={styles.prosIcon}
                            alt='Pros-icon'
                            height={17}
                            width={17}
                            layout='fixed'
                            objectFit='cover'
                            loading='lazy'
                          />
                        </div>
                        <p className={styles.prosText}>
                          {pro.attributes?.description}
                        </p>
                      </div>
                    ))}
                  </ul>
                </div>
                <div className={styles.toplistProsRight}>
                  <div className={styles.toplistItemRating}>
                    <div className={styles.rating}>
                      <p>
                        <div className={styles.ratingSpan}>
                          {getGeneralRatingScore(item.ratings?.data)}

                          <span className={styles.smallerText}>/10</span>
                        </div>
                        <div className={styles.starContainer}>
                          <StarContainer />
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
                <div className={styles.prosRightTablet}>
                  <div className={styles.prosRightTabletUpper}>
                    <div className={styles.upperTabletRating}>
                      <div className={styles.toplistItemRating}>
                        <div className={styles.rating}>
                          <p>
                            <div className={styles.ratingSpan}>
                              {item.ratings?.data[0]?.attributes.score}

                              <span className={styles.smallerText}>/10</span>
                            </div>
                            <div className={styles.starContainer}>
                              <StarContainer />
                            </div>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className={styles.numberTablet}>
                      <p># {index + 1}</p>
                    </div>
                  </div>
                  <div className={styles.prosRightTabletLower}>
                    <div className={styles.lowerTabletLeft}>
                      <div className={styles.readFullReview}>
                        <a href={`/review/${item.slug}`}>
                          <p>{intl.t('review.buttons.read')}</p>
                        </a>
                      </div>
                    </div>
                    <div className={styles.lowerTabletRight}>
                      <a
                        className={styles.startTrading}
                        href={item.affiliateLink}
                        target='_blank'
                        rel='noopener noreferrer nofollow'
                      >
                        <p>
                          {intl.t('review.buttons.visit')} {item.title}
                        </p>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.mobileTags}>
              {item.tags?.data?.map((tag, tagIndex) => (
                <ListTags key={tagIndex} tags={tag} backgroundColor='#1D1D1D' />
              ))}
            </div>
            <div className={styles.toplistArticleLower}>
              <div className={styles.toplistArticleLowerLeft}>
                <div className={styles.readFullReview}>
                  <a href={`/review/${item.slug}`}>
                    <p>{intl.t('review.buttons.read')}</p>
                  </a>
                </div>
                <a
                  className={styles.startTrading}
                  href={item.affiliateLink}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <p>
                    {intl.t('review.buttons.visit')} {item.title}
                  </p>
                </a>
              </div>
              <div className={styles.toplistArticleLowerRight}>
                <a
                  className={styles.offerLink}
                  href={item.affiliateLink}
                  target='_blank'
                  rel='noopener noreferrer nofollow'
                >
                  <div className={styles.toplistItemOffer}>
                    <div className={styles.offerWrap}>
                      <div className={styles.offerType}>{item.offerType}</div>

                      <div className={styles.offer}>{item.offer}</div>
                    </div>
                    <div className={styles.offerButton}>
                      <a
                        className={styles.getDeal}
                        href={item.affiliateLink}
                        target='_blank'
                        rel='noopener noreferrer nofollow'
                      >
                        <button className={styles.getThisDeal}>
                          {item.buttonText}
                        </button>
                      </a>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    ))
  }, [detailedReviewItems])

  return <div className={styles.toplistContainer}>{reviewItems}</div>
}

export default TopList
